export default "__VITE_ASSET__CF0Xr388__"